import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/tipo-de-seguridad-social';

/**
 * GET Tipos de Seguridad Social
 * @returns {Promise<object[]>}
 */
export const getTiposDeSeguridadesSociales = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo de Seguridad Social
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTipoDeSeguridadSocial = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo de Seguridad Social
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeSeguridadSocial = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Seguridad Social
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeSeguridadSocial = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Seguridad Social
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTipoDeSeguridadSocial = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
